import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { v4 as uuidv4 } from "uuid";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";

import { setupAxiosInterceptors } from "utils/axiosConfig";
import { getUser, setUser } from "utils/functions";

import Home from "pages/Home";
import HowToUsePage from "pages/HowToUse";
import OxfordPage from "pages/Oxford";
import AboutPage from "pages/About";
import LegendPage from "pages/Legend";

import "./App.css";

setupAxiosInterceptors();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  const [init, setInit] = useState(false);
  useEffect(() => {
    const userId = getUser();
    if (!userId) {
      setUser(uuidv4());
    }
    setInit(true);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        {!!init && (
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/how-to-use" element={<HowToUsePage />} />
            <Route path="/o3" element={<OxfordPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/legend" element={<LegendPage />} />
          </Routes>
        )}
      </Router>
    </QueryClientProvider>
  );
}

export default App;
